enum ThemeConfig {
    MSlot_Purple = 0,
    MSlot_Gold = 1,
}

export default ThemeConfig;
